import HttpClient from "utils/HttpClient/HttpClient"
import { SUCCESSFUL_GET_MYPAYMENTS } from "./actionConst";
import { SHOW_ERROR_MESSAGE } from 'reducers/application/actionConst';

export const fetchMyPayments = (saleOrderId) => dispatch => {
    new HttpClient(true).get("b2c/my-payments",
        {
            params: {
                saleOrderId: saleOrderId
            }
        })
        .then((response) => {
            console.log("Successful Fetch MyPayments");
            dispatch({
                type: SUCCESSFUL_GET_MYPAYMENTS,
                payload: response.data
            });
        })
        .catch((error) => {
            console.log("Failed Fetch MyPayments");
            dispatch({
                type: SHOW_ERROR_MESSAGE,
                payload: "Error al obtener los pagos"
            });
        })
}


// WEBPACK FOOTER //
// ./src/reducers/mypayments/mypaymentsActions.js